export const DEFAULT_HOST_SYNC_SETTINGS = {
  airbnbAdvanceNotice: 'same_day',
  airbnbSameDayCutoffHour: 17,
  airbnbPreparationTimeNights: 0,
};

export const AIRBNB_ADVANCE_NOTICE_OPTIONS = [
  { value: 'same_day', label: 'Same day' },
  { value: '1', label: '1 day' },
  { value: '2', label: '2 days' },
  { value: '3', label: '3 days' },
  { value: '7', label: '7 days' },
];

export const AIRBNB_PREPARATION_TIME_OPTIONS = [
  { value: 0, label: 'None' },
  { value: 1, label: '1 night before and after each reservation' },
  { value: 2, label: '2 nights before and after each reservation' },
  { value: 3, label: '3 nights before and after each reservation' },
];

export const AIRBNB_SAME_DAY_CUTOFF_OPTIONS = Array.from({ length: 24 }, (_, hour) => {
  const baseHour = hour % 12 || 12;
  const suffix = hour < 12 ? 'AM' : 'PM';
  return {
    value: hour,
    label: `${baseHour}:00 ${suffix}`,
  };
});

export const normalizeHostSyncSettings = (value = {}) => ({
  airbnbAdvanceNotice: value.airbnbAdvanceNotice || value.airbnb_advance_notice || DEFAULT_HOST_SYNC_SETTINGS.airbnbAdvanceNotice,
  airbnbSameDayCutoffHour: value.airbnbSameDayCutoffHour ?? value.airbnb_same_day_cutoff_hour ?? DEFAULT_HOST_SYNC_SETTINGS.airbnbSameDayCutoffHour,
  airbnbPreparationTimeNights: Number(value.airbnbPreparationTimeNights ?? value.airbnb_preparation_time_nights ?? DEFAULT_HOST_SYNC_SETTINGS.airbnbPreparationTimeNights),
});

export const buildHostSyncSettingsPayload = (value = {}) => {
  const normalized = normalizeHostSyncSettings(value);
  return {
    airbnb_advance_notice: normalized.airbnbAdvanceNotice,
    airbnb_same_day_cutoff_hour: normalized.airbnbAdvanceNotice === 'same_day' ? normalized.airbnbSameDayCutoffHour : null,
    airbnb_preparation_time_nights: normalized.airbnbPreparationTimeNights,
  };
};